import { Component, OnInit, Input } from '@angular/core';
import { IHeaderCell } from '../../../holders/header-cell.component';
import { Col } from '../../../../utility/cols/col.class';

@Component({
   selector: 'app-selector-single',
   template: `
      
   `,
   styleUrls: ['./selector-single.component.scss']
})
export class SelectorSingleComponent implements IHeaderCell, OnInit {
   @Input() col: Col<object>;


   ngOnInit() {

   }
}